import { FiCode, FiPenTool, FiTrendingUp, FiShare2 } from 'react-icons/fi';
import i18n from '../../../../i18n';

// Fuente única de las categorías: la usan el gestor de servicios, el detalle de
// usuario y la página de servicios del cliente. Los valores deben coincidir con
// CATEGORIAS_SERVICIO del modelo del servidor.
export const CATEGORIAS = ['desarrollo', 'diseno', 'marketing', 'rrss'];

const ICONO_CATEGORIA = {
    desarrollo: FiCode,
    diseno: FiPenTool,
    marketing: FiTrendingUp,
    rrss: FiShare2,
};

// El label se resuelve en el idioma activo en el momento de llamar, no al
// importar el módulo: por eso es un getter y no un objeto estático.
export const metaCategoria = (categoria) => {
    const clave = ICONO_CATEGORIA[categoria] ? categoria : 'desarrollo';
    return { label: i18n.t(`categoriasServicio.${clave}`), icon: ICONO_CATEGORIA[clave] };
};

// Compatibilidad con quien todavía indexa por objeto en vez de llamar a
// metaCategoria(): un getter por categoría evita que el label quede
// congelado en el idioma que estaba activo al importar el módulo.
export const CATEGORIA_META = Object.fromEntries(
    CATEGORIAS.map((categoria) => [categoria, undefined])
);
CATEGORIAS.forEach((categoria) => {
    Object.defineProperty(CATEGORIA_META, categoria, {
        enumerable: true,
        get: () => metaCategoria(categoria),
    });
});
